import React from "react";
import appConstants from "../../../../../appConstants";
import { DateTimeEditor } from "../../../../dataGrid/cellEditors";
import { format } from "date-fns";
import { CustomDateRenderer } from "../Days";
import {
  checkPlanAlreadyInitialized,
  isHoliday,
  getHolidayName,
} from "../utils";
import { APP_DATE_FORMAT } from "../../constants";
import { withStyles } from "@material-ui/core";

const styles = (theme) => ({
  label: {
    marginRight: 16,
    color: theme.HeaderSelectedText,
    fontWeight: 600,
    fontSize: 14,
  },
});

const DateTimeEditorComponent = ({
  terminalDate,
  holidays,
  initializedDates,
  planDate,
  onDateChanged,
  classes
}) => {
  const renderDay = (day, selectedDate, dayInCurrentMonth, dayComponent) => {
    const holidayName = getHolidayName(day, holidays);
    return (
      <CustomDateRenderer
        day={day}
        selectedDate={selectedDate}
        dayComponent={dayComponent}
        isInitializedPlanDate={checkPlanAlreadyInitialized(
          day,
          initializedDates
        )}
        isHoliday={isHoliday(day, holidays)}
        isDisabled={
          format(day, APP_DATE_FORMAT) < format(terminalDate, APP_DATE_FORMAT)
        }
        holidayName={holidayName}
        dayInCurrentMonth={dayInCurrentMonth}
      />
    );
  };
  return (
    <>
      <span className={classes.label}>Date:</span>
      <DateTimeEditor
        dateType={{
          ...appConstants.DATETYPES.MONTHDATEYEAR,
          updateFormat: "yyyy-MM-dd'T'00:00:00.000",
        }}
        onChange={onDateChanged}
        value={
          format(planDate, appConstants.DATETYPES.MONTHDATEYEAR.format) || null
        }
        minDate={terminalDate}
        renderDay={renderDay}
        minDateMessage="Plan date should not be before current date"
      />
    </>
  );
};

export default withStyles(styles)(DateTimeEditorComponent);
